export const API_EMISSION_FACTORS = 'api/emission-factors'
// ---- EMISSIONS ----
// COMPANY SUMMARY
export const API_GET_COMPANY_EMISSIONS_SUMMARY = 'api/emissions/company-summary'
// SCOPE ONE
export const API_GET_COMPANY_EMISSIONS_SCOPE_ONE = 'api/emissions/company-scope-one'
// SCOPE TWO
export const API_GET_COMPANY_EMISSIONS_SCOPE_TWO = 'api/emissions/company-scope-two'
// SCOPE THREE
export const API_GET_COMPANY_EMISSIONS_SCOPE_THREE = 'api/emissions/company-scope-three'
// GROUP SUMMARY
export const API_GET_GROUP_EMISSIONS_SUMMARY = 'api/emissions/group-summary'
// SCOPE ONE
export const API_GET_GROUP_EMISSIONS_SCOPE_ONE = 'api/emissions/group-scope-one'
// SCOPE TWO
export const API_GET_GROUP_EMISSIONS_SCOPE_TWO = 'api/emissions/group-scope-two'
// SCOPE THREE
export const API_GET_GROUP_EMISSIONS_SCOPE_THREE = 'api/emissions/group-scope-three'
// EXPORT DOCUMENT
// COMPANY
export const API_EXPORT_COMPANY_EMISSIONS_SUMMARY = 'api/emissions/company-emissions-summary'
// GROUP
export const API_EXPORT_GROUP_EMISSIONS_SUMMARY = 'api/emissions/group-emissions-summary'